// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';

// Model imports
import { VendorMissingBillsParameterDto } from '../_models/workflow-vendor-missing-bills/vendor-missing-bills-parameter-dto';
import { VendorMissingBillsResultDto } from '../_models/workflow-vendor-missing-bills/vendor-missing-bills-result-dto';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { VendorMissingBillStatusUpdateParametersDto } from '../_models/workflow-vendor-missing-bills/vendor-missing-bill-status-update-parameters-dto';
import { VendorMissingBillsHistoryParametersDto } from '../_models/workflow-vendor-missing-bills/vendor-missing-bills-history-parameter-dto';
import { VendorMissingBillsHistoryResultDto } from '../_models/workflow-vendor-missing-bills/vendor-missing-bills-history-result-dto';

// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';

@Injectable({
    providedIn: 'root'
})
export class WorkflowVendorMissingBillsService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    getVendorMissingBills(baseParams: VendorMissingBillsParameterDto): Observable<VendorMissingBillsResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}missingbills${baseParams.getQueryString()}`;

        return this.httpClient
            .get<VendorMissingBillsResultDto[]>(url)
            .pipe(map((response) => plainToClass(VendorMissingBillsResultDto, response)));
    }

    getVendorMissingBillStatuses(clearCache = false): Observable<KeyValueResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}missingbills/statuses`;
        this.cacheRegistrationService.registerForCache(url, clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };

        return this.httpClient
            .get<KeyValueResultDto[]>(url, options)
            .pipe(map((response) => plainToClass(KeyValueResultDto, response)));
    }

    updateVendorMissingBill(baseParam: VendorMissingBillStatusUpdateParametersDto): Observable<any> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}missingbills/status`;
        return this.httpClient.put(url, classToPlain(baseParam));
    }

    getVendorMissingBillHistory(
        baseParam: VendorMissingBillsHistoryParametersDto
    ): Observable<VendorMissingBillsHistoryResultDto[]> {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}missingbills/history${baseParam.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParam.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };

        return this.httpClient
            .get<VendorMissingBillsHistoryResultDto[]>(url, options)
            .pipe(map((response) => plainToClass(VendorMissingBillsHistoryResultDto, response)));
    }
}
